// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__10Z0l","heading":"LoginPage_heading__Xuw-l","head":"LoginPage_head__Vm-ny"};